import Filter from "../../components/usuarios/Filtros";
import Usuario from "../../components/usuarios/Usuario";

const Usuarios = ({
    filter,
    setFilter,
    fetch,
    data,
    setData,
    onClick,
    onChange,
    provincias,
    navigate,
    user
  }) => {
    

    return (
        <div className="min-vh-100" style={{ backgroundColor: "#eaeaea" }}>
          <div className="px-3">
            <div className="d-flex">
              <h2 className="me-2">USUARIOS</h2>
              <label
                className="btn btn-custom-naranja fw-normal GothamBold text-white px-4 d-flex align-items-center"
                style={{ borderRadius: "10px", height: "45px" }}
              >
                NUEVO USUARIO
                <button
                  className="d-none"
                  name="añadir-evento"
                  onClick={(event) => onClick(event)}
                ></button>
              </label>
            </div>
            <div className="row">
              <div className="col-md-12">
                <Filter
                  filter={filter}
                  setFilter={setFilter}
                  fetch={fetch}
                  onChange={onChange}
                  provincias={provincias}
                  setData={setData}
                />
              </div>
    
              <div className="col-md-12">
                <div className="my-3">
                  {data.links.map((link) => {
                    if (link.label == "&laquo; Previous") {
                      return (
                        <label
                          className={`btn btn-outline-dark me-1 ${
                            link.active ? "active" : ""
                          } ${link.url ? "" : "disabled"}`}
                        >
                          <i class="bi bi-chevron-left"></i>
                          ANTERIOR
                        </label>
                      );
                    }
                    if (link.label == "Next &raquo;") {
                      return (
                        <label
                          className={`btn btn-outline-dark ${
                            link.active ? "active" : ""
                          } ${link.url ? "" : "disabled"}`}
                        >
                          SIGUIENTE
                          <i class="bi bi-chevron-right"></i>
                        </label>
                      );
                    }
                    return (
                      <label
                        className={`btn btn-outline-dark me-1 ${
                          link.active ? "active" : ""
                        }`}
                      >
                        {link.label}
                      </label>
                    );
                  })}
                  <label className={`btn btn-dark ms-1`}>
                    USUARIOS {data?.total}
                  </label>
                </div>
                <table class="table table-striped-columns table-light table-hover">
                  <thead>
                    <tr>
                      <th className="d-none d-md-table-cell">
                        <div className="d-flex justify-content-between">
                          #ID
                          <label className="d-flex mx-2 btn px-0 py-0">
                            <i
                              class={`bi bi-arrow-down ${
                                filter.sort == "-id"
                                  ? "text-dark font-bold"
                                  : "text-muted opacity-25"
                              }`}
                            ></i>
                            <i
                              class={`bi bi-arrow-up ${
                                filter.sort == "id"
                                  ? "text-dark font-bold"
                                  : "text-muted opacity-25"
                              }`}
                            ></i>
                            <button
                              className="d-none"
                              onClick={() => {
                                let params = filter;
                                if (filter.sort == "-id") {
                                  setFilter({ ...filter, sort: "id" });
                                  params = { ...params, sort: "id" };
                                } else {
                                  setFilter({ ...filter, sort: "-id" });
                                  params = { ...params, sort: "-id" };
                                }
                                fetch(setData, params, "/eventos");
                              }}
                            ></button>
                          </label>
                        </div>
                      </th>
                      <th className="">
                        <div className="d-flex justify-content-between">
                          NOMBRE
                          <label className="d-flex mx-2 btn px-0 py-0">
                            <i
                              class={`bi bi-arrow-down ${
                                filter.sort == "-nombre"
                                  ? "text-dark font-bold"
                                  : "text-muted opacity-25"
                              }`}
                            ></i>
                            <i
                              class={`bi bi-arrow-up ${
                                filter.sort == "nombre"
                                  ? "text-dark font-bold"
                                  : "text-muted opacity-25"
                              }`}
                            ></i>
                            <button
                              className="d-none"
                              onClick={() => {
                                let params = filter;
                                if (filter.sort == "-nombre") {
                                  setFilter({ ...filter, sort: "nombre" });
                                  params = { ...params, sort: "nombre" };
                                } else {
                                  setFilter({ ...filter, sort: "-nombre" });
                                  params = { ...params, sort: "-nombre" };
                                }
                                fetch(setData, params, "/eventos");
                              }}
                            ></button>
                          </label>
                        </div>
                      </th>
                      <th className="d-none d-md-table-cell">
                        <div className="d-flex justify-content-between">
                          EMAIL
                          <label className="d-flex mx-2 btn px-0 py-0">
                            <i
                              class={`bi bi-arrow-down ${
                                filter.sort == "-nombre_sitio"
                                  ? "text-dark font-bold"
                                  : "text-muted opacity-25"
                              }`}
                            ></i>
                            <i
                              class={`bi bi-arrow-up ${
                                filter.sort == "nombre_sitio"
                                  ? "text-dark font-bold"
                                  : "text-muted opacity-25"
                              }`}
                            ></i>
                            <button
                              className="d-none"
                              onClick={() => {
                                let params = filter;
                                if (filter.sort == "-nombre_sitio") {
                                  setFilter({ ...filter, sort: "nombre_sitio" });
                                  params = { ...params, sort: "nombre_sitio" };
                                } else {
                                  setFilter({ ...filter, sort: "-nombre_sitio" });
                                  params = { ...params, sort: "-nombre_sitio" };
                                }
                                fetch(setData, params, "/eventos");
                              }}
                            ></button>
                          </label>
                        </div>
                      </th>
                      <th className="">
                        <div className="d-flex justify-content-between">
                          ROL
                          <label className="d-flex mx-2 btn px-0 py-0">
                            <i
                              class={`bi bi-arrow-down  ${
                                filter.sort == "-fechas.fecha"
                                  ? "text-dark font-bold"
                                  : "text-muted opacity-25"
                              }`}
                            ></i>
                            <i
                              class={`bi bi-arrow-up  ${
                                filter.sort == "fechas.fecha"
                                  ? "text-dark font-bold"
                                  : "text-muted opacity-25"
                              }`}
                            ></i>
                            <button
                              className="d-none"
                              onClick={() => {
                                let params = filter;
                                if (filter.sort == "-fechas.fecha") {
                                  setFilter({ ...filter, sort: "fechas.fecha" });
                                  params = { ...params, sort: "fechas.fecha" };
                                } else {
                                  setFilter({ ...filter, sort: "-fechas.fecha" });
                                  params = { ...params, sort: "-fechas.fecha" };
                                }
                                fetch(setData, params, "/eventos");
                              }}
                            ></button>
                          </label>
                        </div>
                      </th>
                      <th className="d-none d-md-table-cell">
                        <div className="d-flex justify-content-between">
                          CREADO
                          <label className="d-flex mx-2 btn px-0 py-0">
                            <i
                              class={`bi bi-arrow-down ${
                                filter.sort == "-categorias.nombre"
                                  ? "text-dark font-bold"
                                  : "text-muted opacity-25"
                              }`}
                            ></i>
                            <i
                              class={`bi bi-arrow-up ${
                                filter.sort == "categorias.nombre"
                                  ? "text-dark font-bold"
                                  : "text-muted opacity-25"
                              }`}
                            ></i>
                            <button
                              className="d-none"
                              onClick={() => {
                                let params = filter;
                                if (filter.sort == "-categorias.nombre") {
                                  setFilter({
                                    ...filter,
                                    sort: "categorias.nombre",
                                  });
                                  params = { ...params, sort: "categorias.nombre" };
                                } else {
                                  setFilter({
                                    ...filter,
                                    sort: "-categorias.nombre",
                                  });
                                  params = {
                                    ...params,
                                    sort: "-categorias.nombre",
                                  };
                                }
                                fetch(setData, params, "/eventos");
                              }}
                            ></button>
                          </label>
                        </div>
                      </th>
                      <th className="d-none d-md-table-cell">
                        <div className="d-flex justify-content-between">ESTADO</div>
                      </th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.data.map((usuario) => {
                      return (
                        <Usuario
                          data={usuario}
                          onClick={onClick}
                          navigate={navigate}
                          user={user}
                        />
                      );
                    })}
                  </tbody>
                </table>
                <div className="my-3">
                  {data.links.map((link) => {
                    if (link.label == "&laquo; Previous") {
                      return (
                        <label
                          className={`btn btn-outline-dark me-1 ${
                            link.active ? "active" : ""
                          } ${link.url ? "" : "disabled"}`}
                        >
                          <i class="bi bi-chevron-left"></i>
                          ANTERIOR
                        </label>
                      );
                    }
                    if (link.label == "Next &raquo;") {
                      return (
                        <label
                          className={`btn btn-outline-dark ${
                            link.active ? "active" : ""
                          } ${link.url ? "" : "disabled"}`}
                        >
                          SIGUIENTE
                          <i class="bi bi-chevron-right"></i>
                        </label>
                      );
                    }
                    return (
                      <label
                        className={`btn btn-outline-dark me-1 ${
                          link.active ? "active" : ""
                        }`}
                      >
                        {link.label}
                      </label>
                    );
                  })}
                  <label className={`btn btn-dark ms-1`}>
                    USUARIOS {data?.total}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
    )
}

export default Usuarios